var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c("el-header", { staticClass: "my-el-header" }, [
        _c("div", { staticClass: "header" }, [
          _c("div", { staticClass: "jzq-logo" })
        ])
      ]),
      _c("div", { staticClass: "y-header", staticStyle: { height: "60px" } }),
      _c(
        "el-main",
        { style: { "min-height": _vm.height, padding: 0 } },
        [_c("nuxt")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fd0c4ee2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd0c4ee2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./layouts/headernomsg.vue
// module id = 5cDk
// module chunks = 200